module.exports = __webpack_public_path__ + "img/full4-min.e4d42d66.png";